import Grid from '@mui/material/Grid';
import Actions from '../components/Actions';
import ChangeSimDialogComponent from '../components/ChangeSimDialogComponent';
import CustomDialogComponent from '../components/CustomDialogComponent';

const SummarySection = ({
  getEsimQr,
  handleOpenDialog,
  handleRequest,
  loading,
  isDialogOpen,
  handleCloseDialog,
  handleSubmit,
  handleCopyToClipboard,
  register,
  registerOptions,
  description,
  handleDescriptionChange,
  errors,
  newOne,
  newTwo,
  newThree,
  setValue,
  inputChange,
  stateShrink,
  municipalityShrink,
  neighborhoodShrink,
  states,
  municipalities,
  neighborhoods,
  zipcodeShrink,
  addressShrink,
  referenceInput,
  contactPhoneShrink,
  isCustomDialogOpen,
  dialogMessage,
  setIsCustomDialogOpen,
  getSaleOrderDetailAction,
  simOrderId,
  onClose,
  purchase,
}) => (
  <Grid item size={{ xs: 12 }} direction={'column'}>
    <Actions
      order_details={purchase}
      getEsimQr={getEsimQr}
      handleOpenDialog={handleOpenDialog}
      handleRequest={handleRequest}
      loading={loading}
    />

    <ChangeSimDialogComponent
      isDialogOpen={isDialogOpen}
      handleCloseDialog={handleCloseDialog}
      handleSubmit={handleSubmit}
      handleCopyToClipboard={handleCopyToClipboard}
      register={register}
      registerOptions={registerOptions}
      description={description}
      handleDescriptionChange={handleDescriptionChange}
      errors={errors}
      order_details={purchase}
      newOne={newOne}
      newTwo={newTwo}
      newThree={newThree}
      setValue={setValue}
      inputChange={inputChange}
      stateShrink={stateShrink}
      municipalityShrink={municipalityShrink}
      neighborhoodShrink={neighborhoodShrink}
      states={states}
      municipalities={municipalities}
      neighborhoods={neighborhoods}
      zipcodeShrink={zipcodeShrink}
      addressShrink={addressShrink}
      referenceInput={referenceInput}
      contactPhoneShrink={contactPhoneShrink}
    />

    <CustomDialogComponent
      isCustomDialogOpen={isCustomDialogOpen}
      dialogMessage={dialogMessage}
      setIsCustomDialogOpen={setIsCustomDialogOpen}
      getSaleOrderDetailAction={getSaleOrderDetailAction}
      simOrderId={simOrderId}
      onClose={onClose}
    />
  </Grid>
);

export default SummarySection;
